export const SPACE_INSIGHTS_URL = 'ui/organization/spaces/';
export const DEVICE_INSIGHTS_URL = 'ui/organization/devices/';
